"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _initStore = require("@/store/initStore");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ExportWarehouse = _interopRequireDefault(require("./ExportWarehouse.vue"));
var _ImportWarehouse = _interopRequireDefault(require("./ImportWarehouse.vue"));
var _ReportConsignment = _interopRequireDefault(require("./ReportConsignment.vue"));
var _ReportExpiredWarehouse = _interopRequireDefault(require("./ReportExpiredWarehouse.vue"));
var _ReportWarehouse = _interopRequireDefault(require("./ReportWarehouse.vue"));
var OrderPage = /*#__PURE__*/function (_Vue) {
  function OrderPage() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderPage, [].concat(args));
    (0, _defineProperty2.default)(_this, "tabName", "import");
    return _this;
  }
  (0, _inherits2.default)(OrderPage, _Vue);
  return (0, _createClass2.default)(OrderPage, [{
    key: "created",
    value: function created() {
      _initStore.configurationStore.fetchData();
    }
  }, {
    key: "watchRouterQueryType",
    value: function watchRouterQueryType(val) {
      var type = this.$route.query.type;
      if (!!type) {
        this.tabName = type;
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("$route.query.type", {
  immediate: true
})], OrderPage.prototype, "watchRouterQueryType", null);
OrderPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ImportWarehouse: _ImportWarehouse.default,
    ExportWarehouse: _ExportWarehouse.default,
    ReportWarehouse: _ReportWarehouse.default,
    ReportExpiredWarehouse: _ReportExpiredWarehouse.default,
    ReportConsignment: _ReportConsignment.default
  }
})], OrderPage);
var _default = exports.default = OrderPage;